import React from 'react';
import { Link, useParams } from 'react-router-dom';
import ThemeToggle from './ThemeToggle';
import letters from '../data/laddu-letters';
import './Laddu.css';

function LetterIndex() {
  return (
    <div className="laddu-container">
      <div className="laddu-theme-toggle">
        <ThemeToggle />
      </div>
      <div className="laddu-header">
        <h1>Letters to Laddu from Papa</h1>
        <p className="laddu-subtitle">A collection of letters for you to read someday</p>
      </div>
      <nav className="laddu-nav">
        <ul>
          {letters.map((letter) => (
            <li key={letter.slug}>
              <Link to={`/laddu/${letter.slug}`}>
                {letter.title}
                <span className="letter-date">{letter.date}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}

function LetterView() {
  const { letter_slug } = useParams();
  const letter = letters.find((l) => l.slug === letter_slug);

  if (!letter) {
    return (
      <div className="laddu-container">
        <div className="laddu-theme-toggle">
          <ThemeToggle />
        </div>
        <Link to="/laddu" className="laddu-back">&#8592; Back to letters</Link>
        <p>Letter not found.</p>
      </div>
    );
  }

  return (
    <div className="laddu-container">
      <div className="laddu-theme-toggle">
        <ThemeToggle />
      </div>
      <Link to="/laddu" className="laddu-back">&#8592; Back to letters</Link>
      <div className="laddu-letter">
        <div className="laddu-letter-header">
          <h2>{letter.title}</h2>
          <p className="letter-meta">{letter.date}</p>
        </div>
        <div className="laddu-letter-body">
          {letter.content}
        </div>
      </div>
    </div>
  );
}

function Laddu() {
  const { letter_slug } = useParams();

  if (letter_slug) {
    return <LetterView />;
  }

  return <LetterIndex />;
}

export default Laddu;
